import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import * as APIM from '@common/utils/dist/models/api-messages.js';
import * as PL2 from '@common/utils/dist/models/models-pl2.js';
import {UtilsPL2 as U} from '@common/utils/dist/utils/utils-pl2.js';

import {EventAPIService, SendEventInput} from '@services/event-api.service';
import {ServiceDecorator} from './service-decorator';
import {
  AiPosthogEventBuilder,
  CopyPosthogEventBuilder,
  CreatePosthogEventBuilder,
  PosthogSpy,
  ReadPosthogEventBuilder,
} from '@spies/posthog.spy';
import {AiGenerateDocumentEventInput} from '@services/events/ai-events';

@Injectable()
export class PosthogSpyDecorator
  implements EventAPIService, ServiceDecorator<EventAPIService>
{
  private _service: EventAPIService;

  constructor(
    private posthogSpy: PosthogSpy,
    private readPosthogEventBuilder: ReadPosthogEventBuilder,
    private copyPosthogEventBuilder: CopyPosthogEventBuilder,
  ) {}

  setService(service: EventAPIService): void {
    this._service = service;
  }

  sendEvent(input: SendEventInput): Observable<string | void> {
    if (U.isEmpty(this._service)) {
      throw new Error('[PosthogSpyDecorator] service not initialized');
    }

    try {
      switch (input.eventType) {
        case APIM.EventIntent.EntryCreate:
          this.posthogSpy.capture(
            new CreatePosthogEventBuilder().build(
              input.c as Array<PL2.AnyPartialEntryWithId>,
            ),
          );
          break;
        case APIM.EventIntent.EntryRead:
          this.posthogSpy.capture(
            this.readPosthogEventBuilder.build(
              input.c as Array<APIM.IndexQuery>,
            ),
          );
          break;
        case APIM.EventIntent.EntryCopy:
          this.posthogSpy.capture(
            this.copyPosthogEventBuilder.build(
              input.c as Array<APIM.EntryCopy>,
            ),
          );
          break;
        case APIM.EventIntent.AITranslateLesson:
        case APIM.EventIntent.AIAdjustReadingLevel:
          this.posthogSpy.capture(
            new AiPosthogEventBuilder().build(input.eventType),
          );
          break;
        case APIM.EventIntent.AIGenerateNewDocument:
          this.posthogSpy.capture(
            new AiPosthogEventBuilder().build(
              input.eventType,
              (input as AiGenerateDocumentEventInput).documentType,
            ),
          );
          break;
        default:
        // skip
      }
    } catch (err) {
      console.error(err);
    }
    return this._service.sendEvent(input);
  }
}
